import {
  InvitationRequestInterface,
  InvitationResponseInterface,
  MemberResponseInterface,
  PermissionApiRequest
} from '@careapp/angular-sdk';

import { CareAppListActionFactory } from './action-factory';

class StaffActions extends CareAppListActionFactory<MemberResponseInterface> {
  get REQUEST_BULK_IMPORT() {
    return `${this.type}[Request] Bulk Import Staff`;
  }

  get RESPONSE_SUCCESS_BULK_IMPORT() {
    return `${this.type}[Response][Success] Bulk Import Staff`;
  }

  get RESPONSE_FAIL_BULK_IMPORT() {
    return `${this.type}[Response][Fail] Bulk Import Staff`;
  }

  get REQUEST_UPDATE_ROLE() {
    return `${this.type}[Request] Update Role`;
  }

  get RESPONSE_SUCCESS_UPDATE_ROLE() {
    return `${this.type}[Response][Success] Update Role`;
  }

  get RESPONSE_FAIL_UPDATE_ROLE() {
    return `${this.type}[Response][Fail] Update Role`;
  }

  RequestBulkImport(payload: InvitationRequestInterface[]) {
    return {
      type: this.REQUEST_BULK_IMPORT,
      payload
    };
  }

  ResponseSuccessBulkImport(payload: InvitationResponseInterface[]) {
    return {
      type: this.RESPONSE_SUCCESS_BULK_IMPORT,
      payload
    };
  }

  ResponseFailBulkImport(payload: Error) {
    return {
      type: this.RESPONSE_FAIL_BULK_IMPORT,
      payload
    };
  }

  RequestUpdateRole(payload: { id: string; role: PermissionApiRequest }) {
    return {
      type: this.REQUEST_UPDATE_ROLE,
      payload
    };
  }

  ResponseSuccessUpdateRole(payload: { id: string; role: string }) {
    return {
      type: this.RESPONSE_SUCCESS_UPDATE_ROLE,
      payload
    };
  }

  ResponseFailUpdateRole(payload: Error) {
    return {
      type: this.RESPONSE_FAIL_UPDATE_ROLE,
      payload
    };
  }

  constructor() {
    super(`Staff`);
  }
}

export const Staff = new StaffActions();
